<template>
  <fieldset>
    <slot name="legend" />

    <input-card-pan
      ref="panElement"
      v-model="cardPan"
      :input-name="$t('card.number')"
      :input-id="getElementsId[0]"
      @focusNext="$refs.InputFocusController.next()"
    />

    <div class="fields-group" data-type="input-group">
      <input-card-date
        ref="dateElement"
        :input-id-month="getElementsId[1]"
        :input-id-year="getElementsId[2]"
        class="input narrow"
        :style="{ width: computedWidth }"
        @onYear="cardYear = $event"
        @onMonth="cardMonth = $event"
        @focusPrev="$refs.InputFocusController.prev()"
        @focusNext="$refs.InputFocusController.next($event)"
      />
      <input-card-c-v-c
        v-if="isShownSecurityCode"
        ref="CVCElement"
        v-model="cvc"
        :input-id="getElementsId[3]"
        class="input narrow"
        @focusPrev="$refs.InputFocusController.prev()"
      />
    </div>

    <input-focus-controller
      ref="InputFocusController"
      :elements-id="getElementsId"
      :current-element="currentElement"
    />

    <slot name="bottomInfo" />
  </fieldset>
</template>

<script>
import InputCardPan from '@/components/cardElements/InputCardPan';
import InputCardDate from '@/components/cardElements/InputCardDate';
import InputCardCVC from '@/components/cardElements/InputCardCVC';
import InputFocusController from '@/components/cardElements/InputFocusController';

const UZB_CARD_PATTERNS = [8600, 6262, 5614, 9860];

export default {
  name: 'CardInputsMix',
  components: {
    InputCardPan,
    InputCardDate,
    InputCardCVC,
    InputFocusController,
  },
  mounted() {
    this.mounted = true;

    this.$nextTick(this.addEventListeners);
  },
  data() {
    return {
      cardPan: '',
      cardMonth: '',
      cardYear: '',
      cvc: '',
      currentElement: 'panInput',
      mounted: false,
    };
  },
  computed: {
    // eslint-disable-next-line complexity
    isValid() {
      if (!this.mounted) {
        return false;
      }

      if (!this.$refs.panElement.cardIsValid || this.$refs.dateElement.$v.$error) {
        return false;
      }

      if (!this.cardPan || !this.cardMonth || !this.cardYear) {
        return false;
      }

      if (this.isShownSecurityCode) {
        return this.$validate.isNotEmptyString(this.cvc) && !this.$refs.CVCElement.$v.$error;
      }

      return true;
    },
    getElementsId() {
      return [
        'panInput',
        'input-card-date-month',
        'input-card-date-year',
        this.isShownSecurityCode && 'input-card-security-code',
      ].filter(i => i);
    },
    formattedCardPan() {
      if (!this.mounted) {
        return null;
      }

      return this.cardPan.replace(/\s/g, '');
    },
    isShownSecurityCode() {
      if (this.$validate.isNull(this.formattedCardPan)) {
        return true;
      }

      const findedCardByPattern = UZB_CARD_PATTERNS
        .find(pattern => this.formattedCardPan.startsWith(pattern));

      return this.$validate.isUndefined(findedCardByPattern);
    },
    computedWidth() {
      if (this.isShownSecurityCode) {
        return 'calc(50% - (0.64rem * 1))';
      }

      return '100%';
    },
  },
  watch: {
    isShownSecurityCode(val) {
      if (!val) {
        this.cvc = '';
      }
    },
  },
  methods: {
    onFocus(e) {
      this.$refs.InputFocusController.setCurrentIndex(e.target.id);
    },
    addEventListeners() {
      Array.prototype.forEach.call(this.getElementsId, el => {
        document.getElementById(el).addEventListener('focus', this.onFocus.bind(this), false);
      });

      document.getElementById(this.$refs.InputFocusController.getElementByIndex()).focus();
    },
    resetData() {
      this.cardPan = '';
      this.cardMonth = '';
      this.cardYear = '';
      this.cvc = '';

      this.$refs.panElement.reset();
      this.$refs.dateElement.reset();
      this.$refs.CVCElement.reset();
    },
  },
};
</script>
